import { defineComponent as _defineComponent } from 'vue'
import { useField } from "vee-validate";
import { ExclamationCircleIcon, XCircleIcon } from "@heroicons/vue/solid";
//@ts-ignore
import BaseInput from "@/components/form/_base.vue";

interface Props {
    type?: string;
    value?: string | number;
    name: string;
    label: string;
    placeholder: string;
    autocomplete?: string;
    locked?: boolean;
    labelPosition?: "top" | "left";
    labelClass?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    type: { type: String, required: false, default: "text" },
    value: { type: [String, Number], required: false, default: undefined },
    name: { type: String, required: true, default: undefined },
    label: { type: String, required: true, default: undefined },
    placeholder: { type: String, required: true, default: undefined },
    autocomplete: { type: String, required: false, default: "" },
    locked: { type: Boolean, required: false, default: false },
    labelPosition: { type: String, required: false, default: "top" },
    labelClass: { type: String, required: false, default: "" }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { type: string, value: string | number, name: string, label: string, placeholder: string, autocomplete: string, locked: boolean, labelPosition: "top" | "left", labelClass: string }



const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
} = useField(props.name, undefined, {
    initialValue: props.value,
});

function customHandleChange(e: Event) {
    const target = e.target;
    if (props.type === "number") {
        // @ts-ignore
        handleChange(Number(target?.value));
    } else {
        handleChange(e);
    }
}

const __returned__ = { props, inputValue, errorMessage, handleBlur, handleChange, meta, customHandleChange, ExclamationCircleIcon, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})